export default "__VITE_ASSET__CucEBlhW__"